import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionLabel } from './ui/SectionLabel';
import { AlertTriangle } from 'lucide-react';
export function Problem() {
  return <section className="py-14 md:py-16 bg-bio-dark border-y border-bio-gray/30 relative" data-id="element-256">
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-bio-amber/20" data-id="element-257" />

      <div className="container mx-auto px-6 max-w-4xl" data-id="element-258">
        <FadeIn data-id="element-259">
          <SectionLabel text="SYSTEM WARNING // ATROPHY DETECTED" data-id="element-260" />

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-261">
            YOU ARE CURRENTLY LIVING IN A STATE OF{' '}
            <span className="text-bio-amber" data-id="element-262">"BIOLOGICAL ATROPHY."</span>
          </h2>

          <div className="space-y-6 text-lg text-bio-text font-light leading-relaxed" data-id="element-263">
            <p data-id="element-264">
              Years of climate control, processed nutrition, and sedentary
              lifestyles have muted your natural defenses. You are operating on
              a "Just-In-Time" immune system that only reacts when the fire is
              already burning the building down.
            </p>

            <div className="p-6 bg-bio-black border border-bio-amber/20 flex gap-4 items-start" data-id="element-265">
              <AlertTriangle className="w-6 h-6 text-bio-amber shrink-0 mt-1" data-id="element-266" />
              <p className="text-white" data-id="element-267">
                Most people are{' '}
                <strong className="text-bio-amber font-normal" data-id="element-268">
                  "biologically outsourced."
                </strong>{' '}
                You rely on a fragile healthcare system that is one supply-chain
                hiccup away from empty shelves. When the 2:00 AM fever hits or
                the news cycle pivots to a "New Variant," you feel that cold
                knot of helplessness in your stomach.
              </p>
            </div>

            <p data-id="element-269">
              This helplessness comes from dependency. You have been trained to
              be a victim of pathogens rather than a predator of them. You are
              navigating a 21st-century biological landscape with a muffled,
              20th-century defense strategy.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}